import React from 'react';
import Badge from '../ui/Badge';
import Button from '../ui/Button';
import { formatDate } from '../../utils/dateFormat';

export default function StickyHeader({
  studentName,
  age,
  statusLabel,
  statusVariant,
  activityLabel,
  activityVariant,
  assignedTo,
  reviewDate,
  onStartReview,
  onAssignOwner,
  onSetReviewDate,
  onExport,
  ownerEditor,
  reviewEditor
}) {
  return (
    <div className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-slate-200 py-4">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <div className="flex items-center gap-3 flex-wrap">
            <h2 className="sp-value" style={{ fontSize: '20px', fontWeight: 600 }}>
              {studentName}
            </h2>
            <Badge variant={statusVariant}>{statusLabel}</Badge>
            <Badge variant={activityVariant}>{activityLabel}</Badge>
            <span className="text-xs sp-muted">Age {age || 'N/A'}</span>
          </div>
          <div className="mt-2 flex flex-wrap items-center gap-3 text-sm">
            <span className="sp-muted">
              Assigned to:{' '}
              {assignedTo ? (
                <span className="sp-value" style={{ fontWeight: 600 }}>{assignedTo}</span>
              ) : (
                <Badge variant="warning">Unassigned</Badge>
              )}
            </span>
            <span className="sp-muted">
              Review due:{' '}
              {reviewDate ? (
                <span className="sp-value" style={{ fontWeight: 600 }}>{formatDate(reviewDate)}</span>
              ) : (
                <Badge variant="warning">No date set</Badge>
              )}
            </span>
          </div>
          {ownerEditor}
          {reviewEditor}
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <Button onClick={onStartReview} type="button">
            Start safeguarding review
          </Button>
          <Button variant="secondary" onClick={onAssignOwner} type="button">
            Assign owner
          </Button>
          <Button variant="secondary" onClick={onSetReviewDate} type="button">
            Set review date
          </Button>
          <Button variant="ghost" onClick={onExport} type="button">
            Export summary (PDF)
          </Button>
        </div>
      </div>
    </div>
  );
}
